/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';
import * as Bookmarks from './bookmarks';
import * as Engine from './engine';
import * as Delay from './delay';
import * as Watcher from './watcher';

// combine all the consuption reducers
export default combineReducers({
  bookmarks: Bookmarks.default,
  engine: Engine.default,
  delay: Delay.default,
});

export const sagas = [call(Bookmarks.saga), call(Engine.saga), call(Delay.saga), call(Watcher.saga)];
